import dayjs, { Dayjs } from 'dayjs';

export const getDisabledTime = (date?: Dayjs | null) => {
  const isToday = dayjs(date).isSame(dayjs(), 'day');

  if (isToday) {
    const disabledHours: number[] = [];

    for (
      let i = dayjs();
      i.isAfter(dayjs().startOf('day'));
      i = i.subtract(1, 'hour')
    ) {
      disabledHours.push(+i.get('hours'));
    }

    return {
      disabledHours: () => disabledHours,
      disabledMinutes: () => []
    };
  }

  return {
    disabledHours: () => [],
    disabledMinutes: () => []
  };
};
